import {registerTileSchema} from '#core/application/schema-registry.js';

import {AbstractVisualFeature, allVisuals} from '#core/application/modules/visual-feature.js';
import {constructTilePalette} from '#core/application/modules/tiles-cache.js';
import {BasePalette} from '#core/application/modules/base-palette.js';

import TABLE_SCHEMA from './table/table.palette-schema.yaml';
import {generateSkeletonPart} from './skeleton-part/index.js';
import {generateOddsButton} from './odds-button/index.js';

registerTileSchema(TABLE_SCHEMA);

class AllTilesFeature extends AbstractVisualFeature {
    get name() {
        return 'All Tiles';
    }

    getSerializableVisualConfig() {
        const constructInnerTilePalette = tileName =>
            // because FILL_PAGE should be used as default based-on value
            constructTilePalette(tileName, this.logger, BasePalette.palette.FILL_PAGE);

        return {
            SkeletonPart: generateSkeletonPart(constructInnerTilePalette('SKELETON_PART')),
            SelectionButton: generateOddsButton(constructInnerTilePalette('ODDS_BUTTON')),
        };
    }
}

new AllTilesFeature(allVisuals);
